module.exports = __webpack_public_path__ + "img/AlessandraCesano.48e0e106.png";